import React, { Component } from "react";
import Footer from "../components/Footer";
import Navbar from "../components/NavBar";
import img from "../imgs/clearRain.jpeg";
import AmazonIcon from "../imgs/amazonIcon.png";

const jumbotron = {
  backgroundImage: "url(" + img + ")",
  backgroundPosition: "center",
  backgroundRepeat: 'repeat-y',
  backgroundSize: "cover",
  color: "white",
  height: "100vh"
};

export default class News extends Component {
  render() {
    return (
      <div>
        <Navbar />
        <div className="jumbotron jumbotron-fluid" style={jumbotron}>
          <div className="container ">
            <div className="row-fluid">
              <div class="card mb-4">
                {/* <img
                  src={AmazonIcon}
                  style={{ height: "16vh", marginTop: "10vh" }}
                /> */}
                <div class="card-body">
                  <h2
                    class="card-title"
                    style={{ color: "black", marginLeft: 4 }}
                  >
                    Interview on Armenian Enough Podcast
                  </h2>
                </div>
                <div class="card-footer text-muted">
                  <p class="card-text">
                    Listen in on January 21st 2019 to the Armenian Enough Podcast featuring Melineh Petrosian
                  </p>
                </div>
              </div>
              <div class="card mb-4">
                {/* <img
                  src={AmazonIcon}
                  style={{ height: "16vh", marginTop: "10vh" }}
                /> */}
                <div class="card-body">
                  <h2
                    class="card-title"
                    style={{ color: "black", marginLeft: 4 }}
                  >
                    Book Signing
                  </h2>
                </div>
                <div class="card-footer text-muted">
                  <p class="card-text">
                  Come visit the Ararat Center on January 21st featuring Guest Speaker Melineh Petrosian.  
                  </p>
                </div>
              </div>
              <div class="card mb-4">
                {/* <img
                  src={AmazonIcon}
                  style={{ height: "16vh", marginTop: "10vh" }}
                /> */}
                <div class="card-body">
                  <h2
                    class="card-title"
                    style={{ color: "black", marginLeft: 4 }}
                  >
                    Book Signing
                  </h2>
                </div>
                <div class="card-footer text-muted">
                  <p class="card-text">
                    Live Radio Interview with Radio Hamrahh
                  </p>
                </div>
              </div>
              
            </div>
            <div class="card mb-4">
                {/* <img
                  src={AmazonIcon}
                  style={{ height: "16vh", marginTop: "10vh" }}
                /> */}
                <div class="card-body">
                  <h2
                    class="card-title"
                    style={{ color: "black", marginLeft: 4 }}
                  >
                    Book Signing
                  </h2>
                </div>
                <div class="card-footer text-muted">
                  <p class="card-text">
                    Live Radio Interview with Radio Hamrahh
                  </p>
                </div>
              
              
            </div>
          </div>
          
        </div>
      </div>
    );
  }
}
